import {
  Create,
  ListButton,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { HTMLInput } from "@/inputs/HTMLInput";
import { ClientAppInput } from "@/modules/clientApps";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const MailSubjectCreate = () => {
  return (
    <Create actions={<CreateActions />} redirect="list">
      <SimpleForm toolbar={<CreateToolbar />}>
        <ClientAppInput source="clientApp" validate={required()} />
        <TextInput type="text" source="title" validate={[required()]} />
        <TextInput type="text" source="type" validate={[required()]} />
        <HTMLInput source="body" validate={[required()]} />
      </SimpleForm>
    </Create>
  );
};
